import { render, staticRenderFns } from "./SoftwareSource.vue?vue&type=template&id=d9624584&scoped=true&"
import script from "./SoftwareSource.vue?vue&type=script&lang=js&"
export * from "./SoftwareSource.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9624584",
  null
  
)

export default component.exports